import * as React from 'react';
import styled from 'styled-components';
import { Card, Button, Row, Col, LeftAvatarRightTitle } from './index';
import { H3, SubH3, H4 } from '../common';
import { FormattedMessage } from 'react-intl';

interface Props {
  headerTitle: string;
  headerSubtitle: React.ReactElement<any>;
  imgUrl: string;
  subheaderTitle: JSX.Element | string;
  label: React.ReactElement<any> | string;
  buttonText: string | React.ReactElement<FormattedMessage>;
  onClick: React.EventHandler<any>;
  selected?: boolean;
}

const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 1em;
`;
const Title = styled(H3)`
  word-break: break-word;
`;
export const SmallCard: React.StatelessComponent<Props> = props => (
  <Card bordered={false} bodyStyle={{ padding: '1em', margin: '1em' }}>
    <Row type="flex" align="middle" justify="center">
      <Col span={24}>
        <Title>{props.headerTitle}</Title>
      </Col>
      <Col span={24}>
        <SubH3>{props.headerSubtitle}</SubH3>
      </Col>
      <Col span={24} style={{ margin: '1em 0' }}>
        <LeftAvatarRightTitle
          imgSrc={props.imgUrl}
          title={props.subheaderTitle}
        />
      </Col>
      <Col span={24}>
        <H4>{props.label}</H4>
      </Col>
      <Col span={24}>
        <StyledButton
          size="large"
          icon={props.selected ? 'close' : 'plus'}
          onClick={props.onClick}
          type={props.selected ? undefined : 'primary'}
        >
          {props.buttonText}
        </StyledButton>
      </Col>
    </Row>
  </Card>
);



// WEBPACK FOOTER //
// ./app/components/antd/SmallCard.tsx